import React from "react";
import { Modal, Button, Table, Form, InputGroup } from "react-bootstrap";
import { Formik, FieldArray, Field } from "formik";
import { BiPlus, BiTrash, BiSave } from "react-icons/bi";
import * as Yup from "yup";

const B2BPricingSchema = Yup.object().shape({
  b2bPricing: Yup.array().of(
    Yup.object().shape({
      minQty: Yup.number().min(1, "Min Qty must be at least 1").required("Required"),
      price: Yup.number().min(0, "Price cannot be negative").required("Required")
    })
  )
});

const B2BPricingModal = ({ show, onHide, onSave, initialPricing = [] }) => {
  return (
    <Modal show={show} onHide={onHide} centered size="md">
      <Modal.Header closeButton className="bg-light">
        <Modal.Title className="h6 fw-bold mb-0">Configure B2B Pricing Tiers</Modal.Title>
      </Modal.Header>
      <Formik
        initialValues={{ b2bPricing: initialPricing.length > 0 ? initialPricing : [{ minQty: 1, price: 0 }] }}
        validationSchema={B2BPricingSchema}
        onSubmit={(values) => {
          onSave(values.b2bPricing);
          onHide();
        }}
      >
        {({ values, errors, touched, handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <Modal.Body className="p-3">
              <div className="alert alert-info py-2 small mb-3">
                Set multiple minimum quantities (MOQ) for different wholesale prices.
              </div>
              <FieldArray name="b2bPricing">
                {({ push, remove }) => (
                  <Table size="sm" className="mb-0 align-middle">
                    <thead className="bg-light">
                      <tr>
                        <th>Min Qty (MOQ)</th>
                        <th>B2B Price (LKR)</th>
                        <th width="50" className="text-center"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {values.b2bPricing.map((tier, idx) => (
                        <tr key={idx}>
                          <td>
                            <Field
                              name={`b2bPricing[${idx}].minQty`}
                              type="number"
                              className={`form-control form-control-sm ${touched.b2bPricing?.[idx]?.minQty && errors.b2bPricing?.[idx]?.minQty ? 'is-invalid' : ''}`}
                            />
                          </td>
                          <td>
                            <Field
                              name={`b2bPricing[${idx}].price`}
                              type="number"
                              className={`form-control form-control-sm ${touched.b2bPricing?.[idx]?.price && errors.b2bPricing?.[idx]?.price ? 'is-invalid' : ''}`}
                            />
                          </td>
                          <td className="text-center">
                            <Button variant="outline-danger" size="sm" onClick={() => remove(idx)} disabled={values.b2bPricing.length === 1}>
                              <BiTrash />
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colSpan="3">
                          <Button variant="light" size="sm" className="w-100 fw-bold text-primary border" onClick={() => push({ minQty: 1, price: 0 })}>
                            <BiPlus /> Add Tier
                          </Button>
                        </td>
                      </tr>
                    </tfoot>
                  </Table>
                )}
              </FieldArray>
            </Modal.Body>
            <Modal.Footer className="bg-light p-2">
              <Button variant="secondary" size="sm" onClick={onHide}>Cancel</Button>
              <Button variant="primary" size="sm" type="submit" className="fw-bold px-4">
                <BiSave className="me-1" /> Apply Pricing
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default B2BPricingModal;
